(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-bistro-groups"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-dining-groups"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-living-groups"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-mv-tv-department"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mv-tv-series')) {
  customElements.define('mv-tv-series', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      const options = this.querySelector('.mv-tv-size-options');
      if (!options) return;
      const choices = Array.from(options.querySelectorAll('[data-mv-choice]'));
      choices.sort((a, b) => Number(a.dataset.size) - Number(b.dataset.size)).forEach(choice => options.append(choice));
      options.addEventListener('click', event => {
        const choice = event.target.closest('[data-mv-choice]');
        if (!choice || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const source = this.querySelector(`template[data-mv-model="${choice.dataset.mvChoice}"]`);
        if (!source) return;
        event.preventDefault();
        for (const part of ['media', 'copy']) {
          const target = this.querySelector(`[data-mv-${part}]`);
          const contents = source.content.querySelector(`[data-mv-${part}]`);
          if (target && contents) target.replaceChildren(...Array.from(contents.childNodes, node => node.cloneNode(true)));
        }
        choices.forEach(item => {
          if (item === choice) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
